import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalendarEvent, CalendarEventParticipant } from '../../services/definitions.service';
import { DataModelService } from '../../services/data-model.service';

export interface EventStatisticsDialogData {
  event: CalendarEvent;
}

@Component({
  selector: 'app-calendar-event-statistics-dialog',
  templateUrl: './calendar-event-statistics-dialog.component.html',
  styleUrls: ['./calendar-event-statistics-dialog.component.css'],
})
export class CalendarEventStatisticsDialogComponent implements OnInit {
  participants: CalendarEventParticipant[] = [];
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<CalendarEventStatisticsDialogComponent>,
    private dataModel: DataModelService,
    @Inject(MAT_DIALOG_DATA) public data: EventStatisticsDialogData
  ) {}

  ngOnInit(): void {
    this.loadParticipants();
  }

  async loadParticipants(): Promise<void> {
    this.isLoading = true;

    if (!this.data.event?.path) {
      this.isLoading = false;
      return;
    }

    const result = await this.dataModel.getAllCalendarEventParticipants(
      this.data.event.path
    );

    if (result.result && Array.isArray(result.data)) {
      this.participants = result.data.map((raw) =>
        this.dataModel.deserializeCalendarEventParticipant(raw)
      );
    } else {
      this.participants = [];
    }

    this.isLoading = false;
  }

  getParticipantName(participant: CalendarEventParticipant): string {
    const first = participant.firstName || participant.prticipantFirstName || '';
    const last = participant.lastName || participant.participantLastName || '';
    return `${first} ${last}`.trim() || 'Unbekannt';
  }

  /**
   * Returns a formatted registration date string for a participant.
   */
  getRegistrationDate(participant: CalendarEventParticipant): string {
    if (!participant.created) {
      return '';
    }
    const date = participant.created.toDate
      ? participant.created.toDate()
      : new Date(participant.created as any);
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  get attendedCount(): number {
    return this.participants.filter((p) => p.attending).length;
  }

  get notAttendedCount(): number {
    return this.participants.filter((p) => !p.attending).length;
  }

  get totalCount(): number {
    return this.participants.length;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
